import { Box, Grid, Stack, Typography } from "@mui/material";
import OfficeMap from "../atoms/OfficeMap";
import PlaceIcon from "@mui/icons-material/Place";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import FollowUs from "../molecules/FollowUs";
import { useTranslation } from "react-i18next";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useBrandingStore } from "../../stores/Branding";

export default function Footer() {
  const { t } = useTranslation("Footer");
  const branding = useBrandingStore((s) => s.branding);

  return (
    <Grid
      container
      sx={{
        background: "#343434F2",
        bottom: 0,
        color: (theme) => theme.palette.primary.contrastText,
      }}
    >
      {branding.whatWeDo && (
        <Grid size={{ xs: 12, md: 3 }} p={4}>
          <Typography gutterBottom variant="h6">
            {t("WhatWeDo")}
          </Typography>
          <Typography variant="body2" fontWeight={200}>
            {branding.whatWeDo}
          </Typography>
        </Grid>
      )}
      <Grid size={{ xs: 12, md: 3 }} p={4}>
        <Typography gutterBottom variant="h6">
          {t("Contact")}
        </Typography>
        <Stack direction={"column"} spacing={1}>
          {branding?.contact?.email && (
            <Stack direction={"row"}>
              <EmailIcon sx={{ mr: 2 }} />
              <Typography flexGrow={1} fontWeight={200}>
                {branding?.contact?.email}
              </Typography>
            </Stack>
          )}
          {branding?.contact?.phone && (
            <Stack direction={"row"}>
              <PhoneIcon sx={{ mr: 2 }} />
              <Typography flexGrow={1} fontWeight={200}>
                {branding?.contact?.phone}
              </Typography>
            </Stack>
          )}
          {(branding?.contact?.whatsappLabel ||
            branding?.contact?.whatsapp) && (
            <Stack
              direction={"row"}
              component="a"
              href={`https://wa.me/${branding?.contact?.whatsapp}`}
              target="_blank"
              sx={{
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <WhatsAppIcon sx={{ mr: 2 }} />
              <Typography maxWidth={180} fontWeight={200}>
                {branding?.contact?.whatsappLabel ||
                  branding?.contact?.whatsapp}
              </Typography>
            </Stack>
          )}
          {branding?.contact?.address && (
            <Stack direction={"row"}>
              <PlaceIcon sx={{ mr: 2 }} />
              <Typography maxWidth={180} fontWeight={200}>
                {branding?.contact?.address}
              </Typography>
            </Stack>
          )}
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 3 }} p={4}>
        <Typography gutterBottom variant="h6">
          {t("FollowUs")}
        </Typography>
        <Box display="flex">
          <FollowUs />
        </Box>
      </Grid>
      {branding?.contact?.mapEmbed && (
        <Grid size={{ xs: 12, md: 3 }} p={4}>
          <OfficeMap />
        </Grid>
      )}
      <Grid
        size={12}
        textAlign="center"
        sx={{
          background: "#343434",
          p: 2,
          color: (theme) => theme.palette.primary.contrastText,
        }}
      >
        <Stack direction={"row"} justifyContent={"center"} spacing={1}>
          <Typography sx={{ fontWeight: 300 }}>
            {t("Copyright")} © {new Date().getFullYear()}
          </Typography>
          <Typography
            component="a"
            sx={{
              textDecoration: "none",
              color: (theme) => theme.palette.primary.light,
              fontWeight: 300,
            }}
            target="_blank"
            href={branding?.links?.website.link}
          >
            {branding?.links?.website.label || branding?.links?.website.link}
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
}
